import React, { useEffect, useState } from 'react'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { SidebarComponent } from '@syncfusion/ej2-react-navigations'

import SideBar from './SideBar.js'
import styled from 'styled-components'
const td = styled.td`
  width: 50px;
`
function HeaderName () {
  const divStyles = {
    boxShadow: '1px 2px 9px #BBB9B9'
  }
  const divStyles1 = {
    textShadow: '1px 1px 1px #BBB9B9'
  }

  const [showSideBar, setShowSideBar] = useState(true)

  const handleSideBar = e => {
    setShowSideBar(!showSideBar)
  }
  let sidebarObj
  function onCreate () {
    sidebarObj.element.style.visibility = ''
  }
  function open () {
    console.log('Sidebar is opened')
  }
  function close () {
    console.log('Sidebar is closed')
  }

  function toggleClick () {
    sidebarObj.toggle()
  }

  return (
    <div className=''>
      {/* {showSideBar && <SideBar />} */}

      <nav className='main-header navbar navbar-expand navbar-white navbar-light py-3'>
        {/* <!-- Left navbar links --> */}
        <ul className='navbar-nav'>
          {/* <SidebarComponent
            id='default-sidebar'
            ref={SideBar => (sidebarObj = SideBar)}
            style={{ visibility: 'hidden' }}
            close={close}
            open={open}
            created={onCreate}
          ></SidebarComponent> */}

          <li className='nav-item'>
            {/* <ButtonComponent
              onClick={toggleClick}
              id='toggle'
              className='e-btn e-info'
            >
              <i className='fas fa-bars'></i>
            </ButtonComponent> */}

            {/* <button
              value='sidebar'
              onClick={e => handleSideBar(e.target.value)}
              className='nav-link'
              data-widget='pushmenu'
              href='#'
            >
              <i className='fas fa-bars'></i>
            </button> */}
          </li>
        </ul>
        <div className='title' style={{ margin: '20px auto' }}>
          <h2>Finance & Admin Module</h2>
        </div>

        <ul className='navbar-nav ml-auto'></ul>
      </nav>
    </div>
  )
}
export default HeaderName
